import React from "react";

const features = [
  {
    icon: (
      <svg
        width="51"
        height="60"
        viewBox="0 0 51 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_1296_1402"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="51"
          height="60"
        >
          <path d="M51 0H0V60H51V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1296_1402)">
          <path
            d="M22.9688 52.9677C22.9688 52.7321 22.827 52.5196 22.6096 52.429C20.0682 51.3696 18.2812 48.8628 18.2812 45.9375V23.4375C18.2812 20.5123 20.0682 18.0054 22.6096 16.9461C22.827 16.8555 22.9688 16.6429 22.9688 16.4074V16.4062H18.2812C14.398 16.4062 11.25 19.5543 11.25 23.4375V45.9375C11.25 49.8208 14.398 52.9688 18.2812 52.9688H22.9688V52.9677Z"
            fill="#F9FBFC"
          />
          <path
            d="M23.3708 41.3167L36.6292 28.0583"
            stroke="#E1E1E1"
            stroke-width="3"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M30 21.0938L44.0625 2.34375"
            stroke="#050B20"
            stroke-width="3"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.9375 2.34375L25.3895 12.9483"
            stroke="#050B20"
            stroke-width="3"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M48.75 30V23.4375C48.75 19.5543 45.602 16.4062 41.7188 16.4062H38.0747C36.4508 13.6159 33.4612 11.7188 30 11.7188C26.5388 11.7188 23.5493 13.6159 21.9253 16.4062H18.2812C14.398 16.4062 11.25 19.5543 11.25 23.4375V45.9375C11.25 49.8207 14.398 52.9688 18.2812 52.9688H21.9253C23.5492 55.759 26.5388 57.6562 30 57.6562C33.4612 57.6562 36.4507 55.759 38.0747 52.9688H41.7188C45.602 52.9688 48.75 49.8207 48.75 45.9375V39.375"
            stroke="#050B20"
            stroke-width="3"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    ),
    title: "Easy Booking Process",
    description:
      "Booking online takes less than 5 min or give us a call so we can personally assist you",
  },
  {
    icon: (
      <svg
        width="61"
        height="60"
        viewBox="0 0 61 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1296_1413)">
          <g clip-path="url(#clip1_1296_1413)">
            <path
              d="M30.28 2.34375V7.03125"
              stroke="#E1E1E1"
              stroke-width="3"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M49.03 2.34375L44.3425 7.03125"
              stroke="#E1E1E1"
              stroke-width="3"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.7538 36.6607C14.5872 35.4056 13.8738 33.7236 13.8738 31.875C13.8738 30.7464 14.1396 29.6799 14.6123 28.7346L19.2998 19.3596C20.4532 17.0528 22.8379 15.4688 25.5925 15.4688H18.5612C15.8066 15.4688 13.422 17.0528 12.2685 19.3596L7.58102 28.7346C7.1084 29.6799 6.8425 30.7464 6.8425 31.875C6.8425 33.7236 7.55594 35.4056 8.72254 36.6607L26.8458 56.1591C27.7018 57.0802 28.9236 57.6562 30.28 57.6562C31.6364 57.6562 32.8582 57.0802 33.7142 56.1593L33.7956 56.0716L15.7538 36.6607Z"
              fill="#F9FBFC"
            />
            <path
              d="M48.2915 19.3596L52.979 28.7346C53.4516 29.6797 53.7175 30.7464 53.7175 31.875C53.7175 33.7236 53.0041 35.4057 51.8375 36.6608L33.7142 56.1593C32.8582 57.0802 31.6364 57.6562 30.28 57.6562C28.9236 57.6562 27.7018 57.0802 26.8458 56.1593L8.72254 36.6608C7.55594 35.4057 6.8425 33.7236 6.8425 31.875C6.8425 30.7464 7.1084 29.6797 7.58102 28.7346L12.2685 19.3596C13.422 17.0527 15.8066 15.4688 18.5612 15.4688H41.9988C44.7534 15.4688 47.138 17.0527 48.2915 19.3596Z"
              stroke="#050B20"
              stroke-width="3"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.53 2.34375L16.2175 7.03125"
              stroke="#E1E1E1"
              stroke-width="3"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.6649 29.5312H42.8951"
              stroke="#050B20"
              stroke-width="3"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M25.5925 24.8438L30.28 29.5312L34.9675 24.8438"
              stroke="#050B20"
              stroke-width="3"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M30.28 43.5939V29.7307"
              stroke="#050B20"
              stroke-width="3"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1296_1413">
            <rect
              width="60"
              height="60"
              fill="white"
              transform="translate(0.279999)"
            />
          </clipPath>
          <clipPath id="clip1_1296_1413">
            <rect
              width="60"
              height="60"
              fill="white"
              transform="translate(0.279999)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "24/7 Customer Support",
    description: "We offer 24/7 Customer Support via text or call",
  },
  {
    icon: (
      <svg
        width="60"
        height="61"
        viewBox="0 0 60 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1296_1426)">
          <g clip-path="url(#clip1_1296_1426)">
            <g clip-path="url(#clip2_1296_1426)">
              <mask
                id="mask0_1296_1426"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="60"
                height="61"
              >
                <path d="M60 0.75H0V60.75H60V0.75Z" fill="white" />
              </mask>
              <g mask="url(#mask0_1296_1426)">
                <path
                  d="M8.75573 37.4977L35.3054 10.9479C37.136 9.11729 40.104 9.11729 41.9345 10.9479L36.8955 5.90882C35.0649 4.07825 32.0969 4.07825 30.2663 5.90882L3.71668 32.4586C1.88611 34.2892 1.88611 37.2572 3.71668 39.0877L8.75573 44.1267C6.92515 42.2961 6.92515 39.3282 8.75573 37.4977Z"
                  fill="#F9FBFC"
                />
                <path
                  d="M50.1537 19.167C51.9843 20.9976 51.9843 23.9656 50.1537 25.7962L23.6039 52.3458C21.7733 54.1764 18.8053 54.1764 16.9748 52.3458L3.71668 39.0877C1.88611 37.2571 1.88611 34.2891 3.71668 32.4585L30.2663 5.90882C32.0969 4.07824 35.0649 4.07824 36.8955 5.90882L43.5247 12.538L52.9689 3.09375"
                  stroke="#050B20"
                  stroke-width="3"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.9633 31.7958C18.7631 33.2055 19.2051 34.6888 20.2894 35.7732C22.12 37.6037 25.088 37.6037 26.9186 35.7732C28.7492 33.9426 28.7492 30.9746 26.9186 29.144C25.088 27.3134 25.088 24.3454 26.9186 22.5148C28.7492 20.6842 31.7172 20.6842 33.5478 22.5148C34.6321 23.5991 35.0742 25.0825 34.8739 26.4921"
                  stroke="#050B20"
                  stroke-width="3"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.9749 39.0878L20.2894 35.7732"
                  stroke="#050B20"
                  stroke-width="3"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M33.5476 22.5148L36.8621 19.2002"
                  stroke="#050B20"
                  stroke-width="3"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M43.5938 58.406L57.6562 44.3435"
                  stroke="#E1E1E1"
                  stroke-width="3"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1296_1426">
            <rect
              width="60"
              height="60"
              fill="white"
              transform="translate(0 0.75)"
            />
          </clipPath>
          <clipPath id="clip1_1296_1426">
            <rect
              width="60"
              height="60"
              fill="white"
              transform="translate(0 0.75)"
            />
          </clipPath>
          <clipPath id="clip2_1296_1426">
            <rect
              width="60"
              height="60"
              fill="white"
              transform="translate(0 0.75)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Affordable Prices",
    description:
      "Enjoy competitive and transparent pricing on our luxury and performance vehicles, giving you the best value without hidden fees",
  },
  {
    icon: (
      <svg
        width="61"
        height="61"
        viewBox="0 0 61 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1296_1441)">
          <g clip-path="url(#clip1_1296_1441)">
            <path
              d="M23.8265 5.20312C20.1252 5.20312 16.7704 7.38083 15.2636 10.7614L9.16656 24.4406C5.51148 24.6918 2.62375 27.7343 2.62375 31.4531V36.8438C2.62375 40.0798 5.24711 42.7031 8.48312 42.7031H10.0892C10.0978 42.2522 10.1093 41.8014 10.1237 41.3505C9.7423 40.573 9.52727 39.699 9.52727 38.7745L9.42062 34.6172C9.42062 31.5427 10.0462 30.3594 12.3283 29.8997C13.4131 29.6811 14.3213 28.942 14.7658 27.9286L22.2948 10.7614C23.8015 7.38083 27.1564 5.20312 30.8577 5.20312H23.8265Z"
              fill="#F9FBFC"
            />
            <path
              d="M8.48312 42.7031C5.24711 42.7031 2.62375 40.0798 2.62375 36.8438V31.4531C2.62375 27.7343 5.51148 24.6918 9.16656 24.4406L15.2636 10.7614C16.7703 7.38083 20.1251 5.20312 23.8265 5.20312H34.5017C38.0241 5.20312 41.2492 7.1775 42.8511 10.3146L45.8659 16.2188M57.9362 31.4531C57.9362 27.5699 54.7882 24.4219 50.905 24.4219H18.9128M28.5222 16.2188V5.32031M32.7409 42.7031H27.4673M21.022 38.0156C18.4332 38.0156 16.3345 40.1143 16.3345 42.7031C16.3345 45.2919 18.4332 47.3906 21.022 47.3906C23.6107 47.3906 25.7095 45.2919 25.7095 42.7031C25.7095 40.1143 23.6109 38.0156 21.022 38.0156Z"
              stroke="#050B20"
              stroke-width="3"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M57.9362 42.3516C57.9362 46.8497 54.2898 50.5547 49.7917 50.5547C45.2936 50.5547 41.6472 46.9083 41.6472 42.4102C41.6472 37.912 45.3522 34.2656 49.8503 34.2656M43.8152 48.8555L36.3738 56.2969"
              stroke="#E1E1E1"
              stroke-width="3"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1296_1441">
            <rect
              width="60"
              height="60"
              fill="white"
              transform="translate(0.279999 0.75)"
            />
          </clipPath>
          <clipPath id="clip1_1296_1441">
            <rect
              width="60"
              height="60"
              fill="white"
              transform="translate(0.279999 0.75)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Wide Range of Vehicles",
    description:
      "We make renting easy by delivering your vehicle straight to Sacramento International Airport (SMF) or a custom location of your choice, providing ultimate convenience and flexibility.",
  },
];

const WhyChooseUS = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 py-12 gap-12 items-center">
      {/* Left Section */}
      <div className="">
        <h2 className="text-6xl font-medium mb-4">
          Why Choose AMK Elite Car Rentals
        </h2>
        <p className="text-gray-600 mb-8">
          Book with us to have an unforgettable, hassle-free car rental
          experience
        </p>
      </div>

      {/* Right Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        {features.map((feature, index) => (
          <div key={index} className="flex flex-col items-start text-left">
            <div className="text-blue-500 text-4xl mb-2">{feature.icon}</div>
            <h3 className="text-xl font-semibold mb-1">{feature.title}</h3>
            <p className="text-gray-600">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChooseUS;
